<template>
  <section>
    <div class="px-5 md:px-25">
      <TitleBlock :title="content.title" :description="content.description" class="text-center"/>
    </div>
    <ul class="mt-10 md:mt-12.5 md:px-5 max-w-300 mx-auto flex flex-col md:gap-4 transition-[margin_gap_padding]">
      <DropdownCard v-for="dropdown in content.items" :buttons="dropdown.buttons" :content="dropdown.content"
                    :title="dropdown.title" :key="dropdown.flexKey" :background="content.background === 'white' ? 'grey' : 'white'"/>
    </ul>
  </section>
</template>

<script lang="ts">
import {TitleBlock} from '@/components/blocks'
import {DropdownCard} from '@/components/cards'

export default {
  name: 'DropdownsSection',
  components: {DropdownCard, TitleBlock},
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>